/**
 * @description VRM Remote console config
 */

(function () {
    'use strict';

    angular.module('vrm.core')
        .config(RemoteConsoleRoute);

    /**
     * Configure Routing for Login State
     * @param $stateProvider
     * @constructor
     * @ngInject
     */
    function RemoteConsoleRoute($stateProvider) {
        const views = {
                    "base": {
                        template: require('@/angular/views/core/remote-console-2.html'),
                        controller: 'RemoteConsoleController2'
                    }
                };
        $stateProvider
        .state('remote-console-2', {
                url: '/remote-console-2/{id:int}',
                views: views,
                data: {
                    requiresVnc : true,
                },
            })
        .state('installations-remote-console', {
                url: '/installation/{id:int}/remote-console',
                views: views,
                data: {
                    requiresVnc : true,
                },
            })
    }
})();
